export enum RequestStatus {
  Idle = 'idle',
  Loading = 'loading',
  Failed = 'failed',
  Success = 'success',
  Forbidden = 'forbidden',
  UploadFailed = 'uploadFailed',
}
